import { render } from "./QuizTypeOptions.vue?vue&type=template&id=54cb76fc&scoped=true"
import script from "./QuizTypeOptions.vue?vue&type=script&lang=js"
export * from "./QuizTypeOptions.vue?vue&type=script&lang=js"

import "./QuizTypeOptions.vue?vue&type=style&index=0&id=54cb76fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cb76fc"]])

export default __exports__